module.exports = __webpack_public_path__ + "static/media/chromatica-game.2e5e37fd.png";